function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import filter from 'lodash/filter';
import forIn from 'lodash/forIn';
import get from 'lodash/get';
import includes from 'lodash/includes';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import set from 'lodash/set';
import unset from 'lodash/unset';
import { AppContext } from 'context';
import { formatObjectAsDate } from 'helpers/datetime';
import history from 'helpers/history';
import { unfoldObject } from 'helpers/transformers';
import FormContainerAbstract from 'components/FormContainerAbstract';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Button from 'components/Form/Button';
import Statement from 'components/Statement';
import TemplatedFields from 'components/TemplatedFields';
import templateFieldShape from 'shapes/templateFieldShape';
import urlRouteShape from 'shapes/urlRouteShape';
import App, { AlertsBus } from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
import Validator from '../../AccountValidator';
import ProfileBox from './ProfileBox';
import ProfileOptionBox from './ProfileOptionBox';
class AcceptInvitation extends FormContainerAbstract {
    static getDerivedStateFromProps(props, state) {
        const { isInProgress, hasErrors, isRejectInProgress, hasRejectErrors } = props;
        if (isInProgress && !state.isInProgress) {
            return {
                isAcceptInProgress: true
            };
        }
        if (hasErrors && state.isInProgress) {
            return {
                isAcceptInProgress: false
            };
        }
        if (isRejectInProgress && !state.isRejectInProgress) {
            return {
                isRejectInProgress: true
            };
        }
        if (hasRejectErrors && state.isRejectInProgress) {
            return {
                isRejectInProgress: false
            };
        }
        return null;
    }
    componentDidMount() {
        const { invitation } = this.props;
        if (invitation && !this.identities.length) {
            this.props.onFetchTemplate(invitation);
            this.setPasswordRule();
        }
    }
    componentDidUpdate(prevProps) {
        const { invitation, isInProgress, hasErrors, isRejectInProgress, hasRejectErrors } = this.props;
        if (!prevProps.invitation && invitation && !this.identities.length) {
            this.props.onFetchTemplate(invitation);
        }
        if (prevProps.isInProgress && !isInProgress && !hasErrors || prevProps.isRejectInProgress && !isRejectInProgress && !hasRejectErrors) {
            this.navigate();
        }
    }
    onAddValidatorRules(rules) {
        this.validatorRules = _object_spread({}, this.validatorRules, rules);
    }
    onAccept() {
        this.props.onFormProcessing();
        const { identityUID, invitation } = this;
        if (identityUID) {
            this.props.onAccept(invitation, identityUID);
            return;
        }
        const { validatedValues, errors } = this.onValidate(this.validatorRules);
        this.props.onFormErrors(errors);
        if (!errors) {
            const { password } = validatedValues;
            const informationValues = omit(validatedValues, 'password');
            this.props.onAcceptWithNewProfile(invitation, informationValues, password);
        }
    }
    onReject() {
        this.props.onFormProcessing();
        this.props.onReject(this.invitation);
    }
    onValidate(rules) {
        const values = _object_spread({}, get(this.props.formValues, 'values', {}));
        let dateOfBirth;
        if (rules.dateOfBirth) {
            if (values.dateOfBirth && values.dateOfBirth.year && values.dateOfBirth.month && values.dateOfBirth.day) {
                dateOfBirth = formatObjectAsDate(values.dateOfBirth);
            } else {
                dateOfBirth = '';
            }
        }
        const { validatedValues, errors } = Validator.run(_object_spread_props(_object_spread({}, values), {
            dateOfBirth
        }), rules);
        return {
            validatedValues: unfoldObject(validatedValues),
            errors
        };
    }
    get identityUID() {
        if (this.identities.length === 1) return this.identities[0].identityUID;
        return get(this.props.formValues, 'values.identityUID');
    }
    get showPassword() {
        const { countryCode, scope } = this.invitation;
        if (scope !== constants.SCOPE_NAMES.PERSONAL) {
            return !this.hasAidIdentity;
        }
        const regionName = this.findRegionName(countryCode);
        return !this.personalIdentitiesRegions.has(regionName);
    }
    get isAcceptDisabled() {
        const identityUID = get(this.props.formValues, 'values.identityUID');
        const number = this.identities.length;
        return number && !identityUID || !number && (!this.props.informationTemplate || super.isDisabled);
    }
    get isAcceptInProgress() {
        return this.state.isAcceptInProgress;
    }
    get isRejectInProgress() {
        return this.state.isRejectInProgress;
    }
    setPasswordRule() {
        const { showPassword } = this;
        if (showPassword && !this.validatorRules.password) {
            set(this.validatorRules, 'password', 'required, password');
            return;
        }
        if (!showPassword && this.validatorRules.password) {
            unset(this.validatorRules, 'password');
        }
    }
    findRegionName(countryCode) {
        let regionName;
        for(let i = 0; i < this.props.regions.length; i++){
            const region = this.props.regions[i];
            const idx = region.countries.findIndex((c)=>c === countryCode);
            if (idx >= 0) {
                regionName = region.name;
                break;
            }
        }
        return regionName;
    }
    navigate() {
        const { subject } = this.invitation;
        const subjectSegments = subject.split('.');
        if (subjectSegments.length > 1) {
            const app = subjectSegments[0].toLowerCase();
            this.props.onGoToApp(app);
            return;
        }
        const { name, params } = this.props.mainUrlRoute;
        const url = this.getUrl(name, params);
        history.push(url);
    }
    renderProgress() {
        return /*#__PURE__*/ _jsx(Statement, {
            headerMessage: App.messages.headers.processing,
            withIcon: "loader",
            imgSrc: "/aid/assets/svg/progress.svg",
            isOnTop: true,
            children: /*#__PURE__*/ _jsx("p", {
                className: "text--paragraph",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.acceptInvitationInProgress))
            })
        });
    }
    renderHeader() {
        const { invitation } = this;
        const message = get(messages.headers.acceptInvitation, invitation.subject);
        return /*#__PURE__*/ _jsx("header", {
            className: "pageHeader",
            children: /*#__PURE__*/ _jsx("h1", {
                className: "text--h2",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, message))
            })
        });
    }
    renderInvitationInfo() {
        const { invitation } = this;
        const message = get(messages.invitationInfo, invitation.subject);
        if (!message) return null;
        const messageValues = {};
        forIn(invitation.inviter, (value, key)=>{
            messageValues[key] = /*#__PURE__*/ _jsx("b", {
                children: value
            });
        });
        return /*#__PURE__*/ _jsx("p", {
            className: "text--paragraph",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, message), {
                values: messageValues
            }))
        });
    }
    renderAcceptInfoMessage() {
        if (this.blockingIdentities.length) {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.blockingIdentity));
        }
        const number = this.identities.length;
        if (!number) {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.noMatchingIdentity));
        }
        if (number === 1) {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.matchingIdentity));
        }
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.matchingIdentities));
    }
    renderRejectInfoMessage() {
        if (this.blockingIdentities.length) {
            return null;
        }
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.rejectInvitation));
    }
    renderAcceptInfo() {
        return /*#__PURE__*/ _jsxs("p", {
            className: "text--paragraph mb-6",
            children: [
                this.renderAcceptInfoMessage(),
                ' ',
                this.renderRejectInfoMessage()
            ]
        });
    }
    renderAddIdentityFormIntro() {
        if (!this.showPassword && !this.props.informationTemplate.length) {
            return null;
        }
        return /*#__PURE__*/ _jsx("p", {
            className: "text--paragraph mb-6",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.addIdentityForm))
        });
    }
    renderIdentities() {
        // if (this.blockingIdentities.length) {
        //   return this.blockingIdentities.map((identity) => <ProfileBox key={identity.identityUID} identity={identity} />);
        // }
        const number = this.identities.length;
        if (this.blockingIdentities.length || !number) {
            const identityToCreate = pick(this.invitation, [
                'countryCode',
                'scope'
            ]);
            return /*#__PURE__*/ _jsx(ProfileBox, {
                identity: identityToCreate
            });
        }
        if (number === 1) {
            const identity = this.identities[0];
            return /*#__PURE__*/ _jsx(ProfileBox, {
                identity: identity
            }, identity.identityUID);
        }
        return this.identities.map((identity)=>/*#__PURE__*/ _jsx(ProfileOptionBox, {
                identity: identity
            }, identity.identityUID));
    }
    renderPasswordField() {
        if (!this.showPassword) {
            return null;
        }
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "password",
            labelMessage: messages.labels.password,
            formValues: this.props.formValues,
            infoMessage: messages.fieldsInfos.newIdentityPassword,
            children: /*#__PURE__*/ _jsx(Input, {
                type: "password",
                onChange: this.props.onSetFormValue
            })
        });
    }
    renderAddIdentityForm() {
        if (this.blockingIdentities.length || !this.props.informationTemplate) {
            return null;
        }
        return /*#__PURE__*/ _jsxs(Form, {
            className: "mt-6",
            children: [
                this.renderAddIdentityFormIntro(),
                this.renderPasswordField(),
                /*#__PURE__*/ _jsx(TemplatedFields, {
                    template: this.props.informationTemplate,
                    disabledFields: this.disabledFields,
                    formValues: this.props.formValues,
                    messages: messages,
                    localizationResources: this.props.localizationResources,
                    validatorRules: this.validatorRules,
                    onAddValidatorRules: (rules)=>this.onAddValidatorRules(rules),
                    onSetFormValue: this.props.onSetFormValue,
                    onSetFormValues: this.props.onSetFormValues
                })
            ]
        });
    }
    renderAcceptBtn() {
        if (this.blockingIdentities.length) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "col-12 col-sm-6",
            children: /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: App.messages.buttons.accept,
                className: "btn--block btn--filled",
                isDisabled: this.isAcceptDisabled || this.isRejectInProgress,
                onClick: ()=>this.onAccept()
            })
        });
    }
    renderRejectBtn() {
        return /*#__PURE__*/ _jsx("div", {
            className: "col-12 col-sm-6",
            children: /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: App.messages.buttons.reject,
                className: "btn--block",
                isDisabled: this.isAcceptInProgress,
                isInProgress: this.isRejectInProgress,
                onClick: ()=>this.onReject()
            })
        });
    }
    renderActions() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row flex-column-reverse flex-sm-row",
            children: [
                this.renderRejectBtn(),
                this.renderAcceptBtn()
            ]
        });
    }
    render() {
        if (!this.invitation) {
            return null;
        }
        if (this.isAcceptInProgress) {
            return this.renderProgress();
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "pageContentBox",
            children: [
                this.renderHeader(),
                this.renderInvitationInfo(),
                this.renderAcceptInfo(),
                /*#__PURE__*/ _jsx(AlertsBus, {
                    className: "mb-5"
                }),
                this.renderIdentities(),
                this.renderAddIdentityForm(),
                this.renderActions()
            ]
        });
    }
    constructor(props, context){
        super(props);
        this.bls = context.bls;
        this.getUrl = context.getUrl;
        this.invitation = _object_spread({}, props.invitation);
        const { countryCode, scope, allowedCountries, allowedScopes } = this.invitation;
        const isBusiness = includes(constants.BUSINESS_SCOPES, scope);
        const scopeGroup = isBusiness ? constants.BUSINESS_SCOPES : constants.PRIVATE_SCOPES;
        const blockingScopes = scopeGroup.filter((s)=>s !== scope);
        this.blockingIdentities = filter(props.identities, (identity)=>identity.countryCode === countryCode && includes(blockingScopes, identity.scope) && (!allowedScopes || !includes(allowedScopes, identity.scope)));
        this.identities = this.blockingIdentities.length ? [] : filter(props.identities, (identity)=>(identity.countryCode === countryCode || includes(allowedCountries, identity.countryCode)) && (identity.scope === scope || includes(allowedScopes, identity.scope)));
        if (this.identities.length === 1) {
            const { identityUID } = this.identities[0];
            props.onSetFormValues({
                identityUID
            });
        } else if (!this.identities.length) {
            this.hasAidIdentity = false;
            this.personalIdentitiesRegions = props.identities.reduce((acc, identity)=>{
                if (identity.scope === constants.SCOPE_NAMES.PERSONAL) {
                    const identityRegionName = this.findRegionName(identity.countryCode);
                    acc.add(identityRegionName);
                } else {
                    this.hasAidIdentity = true;
                }
                return acc;
            }, new Set());
        }
        this.state = {
            isAcceptInProgress: false,
            isRejectInProgress: false
        };
        this.validatorRules = {};
    }
}
_define_property(AcceptInvitation, "contextType", AppContext);
_define_property(AcceptInvitation, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    invitation: shapes.invitation,
    identities: PropTypes.arrayOf(shapes.identity),
    informationTemplate: PropTypes.arrayOf(templateFieldShape),
    mainUrlRoute: urlRouteShape,
    localizationResources: PropTypes.object,
    regions: PropTypes.arrayOf(App.shapes.region).isRequired,
    isRejectInProgress: PropTypes.bool,
    hasRejectErrors: PropTypes.bool,
    // Implicit actions
    onAccept: PropTypes.func,
    onAcceptWithNewProfile: PropTypes.func,
    onReject: PropTypes.func,
    onFetchTemplate: PropTypes.func,
    onGoToApp: PropTypes.func
}));
const mapStateToProps = ()=>(state)=>({
            invitation: selectors.invitation(state),
            informationTemplate: selectors.invitationInformationTemplate(state),
            identities: selectors.identities(state),
            mainUrlRoute: selectors.mainUrlRoute(state),
            isInProgress: selectors.isAcceptInvitationInProgress(state),
            hasErrors: selectors.hasAcceptInvitationErrors(state),
            isRejectInProgress: selectors.isRejectInvitationInProgress(state),
            hasRejectErrors: selectors.hasRejectInvitationErrors(state),
            formValues: App.selectors.formSelector(constants.ACCEPT_INVITATION_FORM)(state),
            localizationResources: App.selectors.localizationResources(state),
            regions: App.selectors.regions(state)
        });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.ACCEPT_INVITATION_FORM;
    return {
        onAcceptWithNewProfile: (invitation, informationValues, password)=>dispatch(actions.acceptInvitationWithNewProfile(invitation, informationValues, password)),
        onAccept: (invitation, identityUID)=>dispatch(actions.acceptInvitation(invitation, identityUID)),
        onReject: (invitation)=>dispatch(actions.rejectInvitation(invitation)),
        onFetchTemplate: (invitation)=>dispatch(actions.fetchInvitationInformationTemplate(invitation)),
        onGoToApp: (app)=>dispatch(actions.goToApp(app)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedAcceptInvitation = connect(mapStateToProps, mapDispatchToProps)(AcceptInvitation);
export default ConnectedAcceptInvitation;
